export function epochToDate(epoch) {
    let d = new Date(epoch * 1000);
    return d.toLocaleDateString();
}

export function epochToTime(epoch) {
    let d = new Date(epoch * 1000);
    return d.toLocaleTimeString();
}

export function todayEpochStart() {
    let today = new Date();

    let mth = (today.getMonth() + 1);
    if (mth < 10) {
        mth = "0" + mth;
    }

    let day = (today.getDate());
    if (day < 10) {
        day = "0" + day;
    }

    var defaultDate = today.getFullYear() + '-' + mth + '-' + day;

    let tmpDate = new Date(`${defaultDate} 00:00:00`);
    return tmpDate.getTime() / 1000.0;
}

export function todayEpochEnd() {
    let today = new Date();

    let mth = (today.getMonth() + 1);
    if (mth < 10) {
        mth = "0" + mth;
    }

    let day = (today.getDate());
    if (day < 10) {
        day = "0" + day;
    }

    var defaultDate = today.getFullYear() + '-' + mth + '-' + day;

    let tmpDate = new Date(`${defaultDate} 23:59:59`);
    return tmpDate.getTime() / 1000.0;
}

export function getTodayDate() {
    let today = new Date();

    let mth = (today.getMonth() + 1);
    if (mth < 10) {
        mth = "0" + mth;
    }

    let day = (today.getDate());
    if (day < 10) {
        day = "0" + day;
    }

    let defaultDate = today.getFullYear() + '-' + mth + '-' + day;
    return defaultDate;
}

export function getEpochForDayInTimezone(sqlDate, timezone) {

    const date = new Date(sqlDate + 'T00:00:00'); // Assuming time is always 00:00:00

    const options = { timeZone: timezone };
    const dateFormatter = new Intl.DateTimeFormat('en-US', options);

    const dateString = dateFormatter.format(date); // Format the date in the provided timezone
    const [month, day, year] = dateString.split('/').map(Number);

    let startOfDayEpoch = new Date(year, month - 1, day, 0, 0, 0, 0).getTime();
    let endOfDayEpoch = new Date(year, month - 1, day, 23, 59, 59, 999).getTime();

    startOfDayEpoch = startOfDayEpoch / 1000
    endOfDayEpoch = endOfDayEpoch / 1000

    console.log(startOfDayEpoch, endOfDayEpoch)

    return { startOfDayEpoch, endOfDayEpoch };
}

export function getStartAndEndDateOfMonth(sqlDate) {

    const [year, month] = sqlDate.split('-').map(Number);
    
    // Create a date object for the given SQL date
    const date = new Date(year, month - 1, 1); // Months are zero-based in JavaScript (0-January, 1-February, etc.)
    
    // Get the start and end dates of the month
    const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
    const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    console.log(startDate)
    console.log(endDate)

    // Format the dates to YYYY-MM-DD
    const formattedStartDate = convertDateString(startDate)
    const formattedEndDate = convertDateString(endDate)

    return { startDate: formattedStartDate, endDate: formattedEndDate };
}


export function getStartEndMonthEpoch(sqlDate, timeZone) {
    const tmp = getStartAndEndDateOfMonth(sqlDate);

    let startOfMonth = tmp.startDate
    let endOfMonth = tmp.endDate

    console.log(startOfMonth)
    console.log(endOfMonth)


    let start = getEpochForDayInTimezone(startOfMonth, timeZone)
    let end = getEpochForDayInTimezone(endOfMonth, timeZone)

    let epochMonthStart = start.startOfDayEpoch
    let epochMonthEnd = end.endOfDayEpoch


    return { epochMonthStart, epochMonthEnd }
}


function convertDateString(dateString){
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add 1 to month as it's zero-based
    const day = date.getDate().toString().padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate
}

export function convertLuxonDateTimeToSqlFormat(luxDateTime){
    let year = luxDateTime.c.year
    let month
    let day

    if (Number(luxDateTime.c.month) < 10) {
        month = "0" + luxDateTime.c.month
    }
    else {
        month = luxDateTime.c.month
    }

    if (Number(luxDateTime.c.day) < 10) {
        day = "0" + luxDateTime.c.day
    }
    else {
        day = luxDateTime.c.day
    }

    return `${year}-${month}-${day}`
}



export function checkNumeric(val) {
    const re = /^[0-9\b]+$/;

    if ((val === '' || re.test(val))) {
        return true
    }
    else {
        return false
    }
}

export function secsToTimeOfDay(no_of_secs) {
    let hours = Math.floor(no_of_secs / 3600)
    let mins = Math.floor((no_of_secs - (hours * 3600))/60)

    if (hours < 10){
        hours = "0" + hours
    }

    if (mins < 10){
        mins = "0" + mins
    }

    return `${hours}:${mins}`
}

export function epochToHumanReadableTS(epochTime) {
    epochTime = epochTime * 1000; // Replace with your epoch time

    // Specify the target timezone
    const targetTimezone = 'Asia/Singapore'; // Replace with your desired timezone

    // Create a new Date object using the epoch time
    const date = new Date(epochTime);

    // Create an options object for formatting the date
    const options = {
        timeZone: targetTimezone,
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
//        timeZoneName: 'short'
    };

    // Format the date using the specified options
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

    return formattedDate
}

export function secsToHumanReadable(seconds) {
    if (typeof seconds !== 'number' || isNaN(seconds)) {
        return 'Invalid input';
    }

    const days = Math.floor(seconds / (3600 * 24));
    const hours = Math.floor((seconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const parts = [];
    if (days > 0) {
        parts.push(days + ' days' );
    }
    if (hours > 0) {
        parts.push(hours + ' hours' );
    }
    if (minutes > 0) {
        parts.push(minutes + ' mins' );
    }
    if (remainingSeconds > 0) {
        parts.push(remainingSeconds + ' secs' );
    }

    if (parts.length === 0) {
        return '0 seconds';
    }

    return parts.join(', ');
}

export function pretty_print_json(jsonString) {

    // Replace double backslashes with single backslashes
    const unescapedString = jsonString.replace(/\\\\/g, '\\');

    // Parse the JSON string into an object
    const jsonObject = JSON.parse(unescapedString);

    // Prettify the JSON object with indentation (using 2 spaces here)
    const prettyJsonString = JSON.stringify(jsonObject, null, 2);

    return prettyJsonString
}

export function loadSettings(settings){

    let tmp_json = {}

    for (let index = 0; index < settings.length; index++) {
        const setting = settings[index];
        
        tmp_json[setting.setting] = setting.attr
    }

    return tmp_json
}

export function getAlertLvl(vol_percent,alerts) {
    let alert_lvl

    Object.keys(alerts).forEach(key => {
        let alert = alerts[key]
        if (vol_percent > alert.threshold_min && vol_percent <= alert.threshold_max) {
            alert_lvl = alert
        }
    });

    return alert_lvl
}